module.exports = __webpack_public_path__ + "img/chat_bubble-white-18dp.6bf37fd8.svg";